import { c as _c } from "react/compiler-runtime";
import { SortDirection } from "@/entities/ISort";
import { ProfileRatersParamsOrderBy, ProfileRatersTableType } from "@/enums";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import ProfileRatersTableHeaderSortableCell from "./ProfileRatersTableHeaderSortableCell";
export default function ProfileRatersTableHeader(t0) {
  const $ = _c(17);
  const {
    type,
    sortDirection,
    sortOrderBy,
    isLoading,
    onSortTypeClick
  } = t0;
  let t1;
  if ($[0] !== type) {
    t1 = () => {
      switch (type) {
        case ProfileRatersTableType.CIC_RECEIVED:
        case ProfileRatersTableType.CIC_GIVEN:
          {
            return "Total NIC";
          }
        case ProfileRatersTableType.REP_RECEIVED:
        case ProfileRatersTableType.REP_GIVEN:
          {
            return "Total Rep";
          }
        default:
          {
            assertUnreachable(type);
            return "";
          }
      }
    };
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getTotalTitle = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <th className="tw-whitespace-nowrap tw-px-4 sm:tw-px-6 lg:tw-pr-4 tw-py-3.5 tw-text-left tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400">Name</th>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = getTotalTitle();
  let t4;
  if ($[3] !== isLoading || $[4] !== onSortTypeClick || $[5] !== sortDirection || $[6] !== sortOrderBy || $[7] !== t3) {
    t4 = <ProfileRatersTableHeaderSortableCell title={t3} sortType={ProfileRatersParamsOrderBy.RATING} sortDirection={sortDirection} sortOrderBy={sortOrderBy} isLoading={isLoading} onSortTypeClick={onSortTypeClick} />;
    $[3] = isLoading;
    $[4] = onSortTypeClick;
    $[5] = sortDirection;
    $[6] = sortOrderBy;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isLoading || $[10] !== onSortTypeClick || $[11] !== sortDirection || $[12] !== sortOrderBy) {
    t5 = <ProfileRatersTableHeaderSortableCell title="Last Updated" sortType={ProfileRatersParamsOrderBy.LAST_MODIFIED} sortDirection={sortDirection} sortOrderBy={sortOrderBy} isLoading={isLoading} onSortTypeClick={onSortTypeClick} />;
    $[9] = isLoading;
    $[10] = onSortTypeClick;
    $[11] = sortDirection;
    $[12] = sortOrderBy;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <thead className="tw-border-b tw-border-x-0 tw-border-t-0 tw-border-white/10"><tr>{t2}{t4}{t5}</tr></thead>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}